/*
 * Lib Module Benchmark
 *
 * JS benchmarking
 */

class Benchmark {


    constructor() {
        this.benchMarks = {};
    }

    start(identifier) {
        if (Lib.Debug.isDebug()) {
            if ('performance' in window) {
                this.benchMarks[identifier] = performance.now();
            } else {
                Lib.Debug.warn('Performance API not available in your browser.');
            }
        }
    };

    stop(identifier, options_) {

        if (Lib.Debug.isDebug()) {

            var options = $.extend(true, {
                log: false,
                max: false
            }, options_);

            if ('performance' in window) {

                if (!identifier in this.benchMarks) {
                    Lib.Debug.warn('Calling Lib.Benchmark.stop() with an uninitialized identifier');
                    return false;
                }


                var timeTaken = -(this.benchMarks[identifier] - performance.now()).toFixed(3);

                if (options.log) {
                    Lib.Debug.info(identifier + ': ' + timeTaken.toFixed(3) + 'ms');
                }

                if (options.max && options.max <= parseFloat(timeTaken + '')) {
                    Lib.Debug.warn('Benchmark `' + identifier + '` took longer than ' + options.max + 'ms! It took ' + timeTaken + 'ms.');
                }

                delete this.benchMarks[identifier];

                return timeTaken;

            } else {
                Lib.Debug.warn('Performance API not available in your browser.');
            }
        }
    };

}

Lib.Benchmark = new Benchmark;
